/**
 * Builds the tap-to-cycle order for script-language presentation items.
 *
 * Canonical order is native script → kana → romanization. The list is rotated
 * so the taught form (`itemValue`) is first, leaving the initial display unchanged.
 * Cycling is only enabled when a romanization value is present.
 */
export const buildScriptFormCycle = ({
  itemValue,
  nativeScript,
  kana,
  romanization,
}: {
  itemValue: string;
  nativeScript?: string | null;
  kana?: string | null;
  romanization?: string | null;
}): string[] => {
  if (!romanization) {
    return [itemValue];
  }

  const scriptForm =
    (nativeScript && nativeScript !== romanization && nativeScript !== kana
      ? nativeScript
      : null) ?? (itemValue !== romanization && itemValue !== kana ? itemValue : null);

  const unique: string[] = [];
  for (const form of [scriptForm, kana, romanization]) {
    if (form && !unique.includes(form)) {
      unique.push(form);
    }
  }

  if (!unique.includes(itemValue)) {
    unique.unshift(itemValue);
  }

  if (unique.length < 2) {
    return [itemValue];
  }

  const startIndex = unique.indexOf(itemValue);
  if (startIndex <= 0) {
    return unique;
  }

  return [...unique.slice(startIndex), ...unique.slice(0, startIndex)];
};
